"use client";

import { Card } from "@/components/ui/card";
import { useTranslations } from "next-intl";

export default function StepsCard() {
  const t = useTranslations("Index.StepsCard");

  return (
    <div
      className="max-w-screen-lg scroll-mt-28 mx-2 lg:mx-auto md:w-full"
      id="how-it-works"
    >
      <Card className="w-full p-8 flex flex-col md:flex-row gap-8 justify-between items-start md:items-center">
        <div className="flex gap-4">
          <img
            src="https://cdn.prod.website-files.com/5ddbd5d1cd7d378da32a8223/65d73f9999bd8e67731ef385_Sign%20Up_Icon.png"
            className="h-12 w-12 object-contain"
            alt="Sign Up Icon"
          />
          <div className="flex flex-col gap-1">
            <p className="font-bold">{t("Point1.title")}</p>
            <p>{t("Point1.body")}</p>
          </div>
        </div>

        <div className="flex gap-4">
          <img
            src="https://cdn.prod.website-files.com/5ddbd5d1cd7d378da32a8223/65d73f4428c888fe59676641_Scan_Icons.png"
            className="h-12 w-12 object-contain"
            alt="Scan Icon"
          />
          <div className="flex flex-col gap-2">
            <p className="font-bold">{t("Point2.title")}</p>
            <p>{t("Point2.body")}</p>
          </div>
        </div>

        <div className="flex gap-4">
          <img
            src="https://cdn.prod.website-files.com/5ddbd5d1cd7d378da32a8223/65d7373d118d914efee5dd7b_Photos_Icons.png"
            className="h-12 w-12 object-contain"
            alt="Photos Icon"
          />
          <div className="flex flex-col gap-2">
            <p className="font-bold">{t("Point3.title")}</p>
            <p>{t("Point3.body")}</p>
          </div>
        </div>
      </Card>
    </div>
  );
}
